<app-navbar title="Przystanki">
	<!-- <button class="btn btn-primary me-4" (click)="showAdd()"><i class="fas fa-plus"></i>Dodaj</button> -->
</app-navbar>

<div id="loader" *ngIf="loader">
	<span class="spinner-border spinner-grow-lg"></span>
</div>

<app-simple-component [selectedElement]="data" (submited)="submit()" (deleted)="deleteReturn($event)">
	<div class="form-floating mb-3">
		<input type="text" class="form-control" id="name" name="name" [(ngModel)]="data.name" required />
		<label for="name">Nazwa statusu</label>
	</div>
	<div class="form-floating mb-3">
		<input type="text" class="form-control" id="detail" name="detail" [(ngModel)]="data.detail" required />
		<label for="detail">Adres</label>
	</div>
</app-simple-component>

<app-dynamic-table
	[elements]="elements"
	[tableRows]="tableRows"
	[haveLink]="false"
	[haveButton]="true"
	(buttonClicked)="selectItem($event)"
></app-dynamic-table>
